import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Delay scroll to let mobile menu close animation complete
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 300);
    }
  };
  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-161">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="flex justify-between items-center" data-id="element-163">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={handleLogoClick} data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/ftH2pUqynHNmgSwuNa6Kz8/LOGO_-_5000px.png" alt="KittyPot logo" className="h-28 w-28 object-contain rounded-full" data-id="element-165" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-166">
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-167">
              How It Works
            </button>
            <button onClick={() => scrollToSection('use-cases')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-168">
              Use Cases
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-169">
              Pricing
            </button>
            <button onClick={() => navigate('/contact')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-170">
              Contact Us
            </button>
            <button onClick={() => scrollToSection('waitlist')} className="bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark px-5 py-2.5 rounded-full font-semibold transition-all shadow-sm hover:shadow-md active:scale-95" data-id="element-171">
              Join Waitlist
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-172">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-173" /> : <Menu className="w-6 h-6" data-id="element-174" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-175">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-176">
            <div className="px-6 pt-4 pb-8 flex flex-col gap-2" data-id="element-177">
              <button onClick={() => scrollToSection('how-it-works')} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-178">
                How It Works
              </button>
              <button onClick={() => scrollToSection('use-cases')} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-179">
                Use Cases
              </button>
              <button onClick={() => scrollToSection('pricing')} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-180">
                Pricing
              </button>
              <button onClick={() => {
            setIsMobileMenuOpen(false);
            navigate('/contact');
          }} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-181">
                Contact Us
              </button>
              <button onClick={() => scrollToSection('waitlist')} className="bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark px-5 py-4 rounded-xl font-semibold text-center text-lg mt-3 active:scale-[0.98] transition-all" data-id="element-182">
                Join Waitlist
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}